<template>
	<transition
			appear
			:appear-active-class="$_admnTabLyt_stylePageLayoutAnimation()">
		<v-row id="_admnTabLyt_top" no-gutters>
			<v-col cols="auto">
				<v-tabs v-model="tabNumber_"
				
						class="tabs_"
						vertical

						:background-color="$_admnTabLyt_styleTabsBackgroundColor"
						:color="$_admnTabLyt_styleTabsColor"
						:dark="$_admnTabLyt_styleTabsDark"
						:hide-slider="$_admnTabLyt_styleTabsHideSlider"
						:light="$_admnTabLyt_styleTabsLight"
						:slider-color="$_admnTabLyt_styleTabsSliderColor"

						@change="$_admnTabLyt_changeTab()">
					<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
						<v-tab	:key="contentKey"
								class="caption"
								
								:dark="$_admnTabLyt_styleTabDark"
								:light="$_admnTabLyt_styleTabLight"

								v-html="$_admnTabLyt_langContentTabTitle(contentVals)" />
					</template>
				</v-tabs>
			</v-col>
			<v-spacer />
			<!-- tab content -->
			<v-col cols="9">
				<v-tabs-items
						class="tabs_"
						v-model="tabNumber_">
					<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
						<v-tab-item :key="contentKey">
							<v-row	class="row_"
									no-gutters>
								<v-col>
									<v-row justify="center">
										<v-col>
											<v-sheet
													class="customVSheet pa-3"
													:color="$_admnTabLyt_styleHeaderSheetColor"
													:dark="$_admnTabLyt_styleHeaderSheetDark"
													:elevation="$_admnTabLyt_styleHeaderSheetElevation"
													:light="$_admnTabLyt_styleHeaderSheetLight">
												<v-card color="transparent" flat>
													<v-card-text class="center">
														<center>
															<span	class="headline"
																	v-html="$_admnTabLyt_langContentTitle(contentVals)" />
														</center>
													</v-card-text>
												</v-card>
											</v-sheet>
										</v-col>
									</v-row>
									<v-row>
										<v-col>
											<v-sheet
													class="customVSheet"
													:color="$_admnTabLyt_styleBodySheetColor"
													:dark="$_admnTabLyt_styleBodySheetDark"
													:elevation="$_admnTabLyt_styleBodySheetElevation"
													:light="$_admnTabLyt_styleBodySheetLight">
												<v-card	class="customVCard"
														color="transparent"
														flat>
													<v-row>
														<v-col>
															<v-row no-gutters>
																<v-col>
																	<v-card-text>
																		<span v-html="$_admnTabLyt_langContentText(contentVals)" />
																	</v-card-text>
																</v-col>
															</v-row>
															<v-row no-gutters>
																<v-col>
																	<v-card-actions>
																		<v-row dense>
																			<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
																				<v-col :key="actionButtonKey" cols="auto">
																					<v-btn	class="customVBtn"
																							:block="$_admnTabLyt_styleActionButtonBlock"
																							:color="$_admnTabLyt_styleActionButtonColor"
																							:dark="$_admnTabLyt_styleActionButtonDark"
																							:depressed="$_admnTabLyt_styleActionButtonDepressed"
																							:elevation="$_admnTabLyt_styleActionButtonElevation"
																							:large="$_admnTabLyt_styleActionButtonLarge"
																							:light="$_admnTabLyt_styleActionButtonLight"
																							:outlined="$_admnTabLyt_styleActionButtonOutlined"
																							:rounded="$_admnTabLyt_styleActionButtonRounded"
																							:small="$_admnTabLyt_styleActionButtonSmall"
																							:text="$_admnTabLyt_styleActionButtonFlat"
																							@click="openLink(actionButtonVals.link)"
																							v-text="$_admnTabLyt_langActionButtonTitle(actionButtonVals)" />
																				</v-col>
																			</template>
																		</v-row>
																	</v-card-actions>
																</v-col>
															</v-row>
														</v-col>
													</v-row>
												</v-card>
											</v-sheet>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col>
									<v-stepper
											id="_admnTabLyt_stepperTop"
											v-model="stepNumber_"
											class="stepper_"
											:dark="$_admnTabLyt_styleStepperDark"
											:light="$_admnTabLyt_styleStepperLight"
											:vertical="$_admnTabLyt_stateAppIsMobileScreen">
										<template v-if="!$_admnTabLyt_stateAppIsMobileScreen">
											<v-row>
												<v-col>
													<v-card class="customVCard"
															:color="$_admnTabLyt_styleStepperCardColor"
															:dark="$_admnTabLyt_styleStepperCardDark"
															:elevation="$_admnTabLyt_styleStepperCardElevation"
															:flat="$_admnTabLyt_styleStepperCardFlat"
															:hover="$_admnTabLyt_styleStepperCardHover"
															:light="$_admnTabLyt_styleStepperCardLight"
															:outlined="$_admnTabLyt_styleStepperCardOutlined"
															:raised="$_admnTabLyt_styleStepperCardRaised"
															:tile="$_admnTabLyt_styleStepperCardTile">
														<v-stepper-header class="stepperHeader_">
															<v-row>
																<template v-for="(stepVals, stepKey) in steps_">
																	<v-col :key="stepKey">
																		<v-card class="customVCard"
																				:color="$_admnTabLyt_styleStepperHeaderCardColor"
																				:dark="$_admnTabLyt_styleStepperHeaderCardDark"
																				:elevation="$_admnTabLyt_styleStepperHeaderCardElevation"
																				:flat="$_admnTabLyt_styleStepperHeaderCardFlat"
																				:hover="$_admnTabLyt_styleStepperHeaderCardHover"
																				:light="$_admnTabLyt_styleStepperHeaderCardLight"
																				:outlined="$_admnTabLyt_styleStepperHeaderCardOutlined"
																				:raised="$_admnTabLyt_styleStepperHeaderCardRaised"
																				:tile="$_admnTabLyt_styleStepperHeaderCardTile">
																			<v-stepper-step 
																					class="stepperStep_"
																					:color="$_admnTabLyt_styleStepperStepColor"
																					:complete="completedSteps_[stepKey]"
																					:step="stepVals.stepNumber">
																				<span v-html="$_admnTabLyt_langContentTitle(stepVals)" />
																			</v-stepper-step>
																		</v-card>
																	</v-col>
																</template>
															</v-row>
														</v-stepper-header>
													</v-card>
												</v-col>
											</v-row>
										</template>
										<!-- stepper body -->
										<v-stepper-items class="stepperItem_">
											<!-- stepper body (input) -->
											<v-stepper-content
													class="stepperContent_"
													step="1">
												<v-row>
													<v-col>
														<validation-observer ref="observerInput" v-slot="validation">
															<v-form>
																<v-card class="customVCard card_"
																		:color="$_admnTabLyt_styleStepperBodyCardColor"
																		:dark="$_admnTabLyt_styleStepperBodyCardDark"
																		:elevation="$_admnTabLyt_styleStepperBodyCardElevation"
																		:flat="$_admnTabLyt_styleStepperBodyCardFlat"
																		:hover="$_admnTabLyt_styleStepperBodyCardHover"
																		:light="$_admnTabLyt_styleStepperBodyCardLight"
																		:outlined="$_admnTabLyt_styleStepperBodyCardOutlined"
																		:raised="$_admnTabLyt_styleStepperBodyCardRaised"
																		:tile="$_admnTabLyt_styleStepperBodyCardTile">
																	<template v-for="(inputItemVals, inputItemKey) in contentVals.inputItems">
																		<v-row  :key="inputItemKey"
																				class="px-4"
																				align="center"
																				no-gutters>
																			<v-col cols="3" class="pr-4">
																				<v-row no-gutters justify="end">
																					<v-col cols="auto">
																						<span v-text="inputItemVals.title" />
																					</v-col>
																				</v-row>
																			</v-col>
																			<v-col cols="9">
																				<template v-if="inputItemVals.type.checkbox">
																					<admin-checkbox
																							:contentKey="contentKey"
																							:inputItemKey="inputItemKey"
																							:contents="contents"
																							:inits="inits" />
																				</template>
																				<template v-if="inputItemVals.type.datePicker">
																					<admin-date-picker
																							:contentKey="contentKey"
																							:inputItemKey="inputItemKey"
																							:contents="contents"
																							:inits="inits" />
																				</template>
																				<template v-if="inputItemVals.type.radioButton">
																					<admin-radio-button
																							:contentKey="contentKey"
																							:inputItemKey="inputItemKey"
																							:contents="contents"
																							:inits="inits" />
																				</template>
																				<template v-if="inputItemVals.type.switch">
																					<admin-switch
																							:contentKey="contentKey"
																							:inputItemKey="inputItemKey"
																							:contents="contents"
																							:inits="inits" />
																				</template>
																				<template v-if="inputItemVals.type.textarea">
																					<admin-textarea
																							:contentKey="contentKey"
																							:inputItemKey="inputItemKey"
																							:contents="contents"
																							:inits="inits" />
																				</template>
																				<template v-if="inputItemVals.type.textareaMarkdown">
																					<admin-textarea-markdown
																							:contentKey="contentKey"
																							:inputItemKey="inputItemKey"
																							:contents="contents"
																							:inits="inits" />
																				</template>
																				<template v-if="inputItemVals.type.textField">
																					<admin-text-field
																							:contentKey="contentKey"
																							:inputItemKey="inputItemKey"
																							:contents="contents"
																							:inits="inits" />
																				</template>
																				<!-- for user -->
																				<template v-if="inputItemVals.type.username">
																					<admin-select-username
																							:contentKey="contentKey"
																							:inputItemKey="inputItemKey"
																							:contents="contents"
																							:inits="inits" />
																				</template>
																				<template v-if="inputItemVals.type.userGroupCode">
																					<admin-select-user-group-code
																							:contentKey="contentKey"
																							:inputItemKey="inputItemKey"
																							:contents="contents"
																							:inits="inits" />
																				</template>
																				<template v-if="inputItemVals.type.securityGroupCode">
																					<admin-select-security-group-code
																							:contentKey="contentKey"
																							:inputItemKey="inputItemKey"
																							:contents="contents"
																							:inits="inits" />
																				</template>
																				<!-- for point -->
																				<template v-if="inputItemVals.type.criteriumCode">
																					<admin-select-criterium-code
																							:contentKey="contentKey"
																							:inputItemKey="inputItemKey"
																							:contents="contents"
																							:inits="inits" />
																				</template>
																				<template v-if="inputItemVals.type.voucherCode">
																					<admin-select-voucher-code
																							:contentKey="contentKey"
																							:inputItemKey="inputItemKey"
																							:contents="contents"
																							:inits="inits" />
																				</template>
																				<!-- for training -->
																				<template v-if="inputItemVals.type.trainingCourseCode">
																					<admin-select-training-course-code
																							:contentKey="contentKey"
																							:inputItemKey="inputItemKey"
																							:contents="contents"
																							:inits="inits" />
																				</template>
																				<template v-if="inputItemVals.type.trainingModuleCode">
																					<admin-select-training-module-code
																							:contentKey="contentKey"
																							:inputItemKey="inputItemKey"
																							:contents="contents"
																							:inits="inits" />
																				</template>
																				<template v-if="inputItemVals.type.trainingSectionCode">
																					<admin-select-training-section-code
																							:contentKey="contentKey"
																							:inputItemKey="inputItemKey"
																							:contents="contents"
																							:inits="inits" />
																				</template>
																			</v-col>
																		</v-row>
																	</template>
																</v-card>
																<v-card	class="customVCard"
																		color="transparent"
																		flat>
																	<v-card-actions>
																		<v-row	align="center"
																				justify="center">
																			<v-col cols="auto">
																				<v-btn	class="customVBtn"
																						:block="$_admnTabLyt_styleStepperActionButtonBlock"
																						:color="$_admnTabLyt_styleStepperActionButtonColor"
																						:dark="$_admnTabLyt_styleStepperActionButtonDark"
																						:depressed="$_admnTabLyt_styleStepperActionButtonDepressed"
																						:elevation="$_admnTabLyt_styleStepperActionButtonElevation"
																						:large="$_admnTabLyt_styleStepperActionButtonLarge"
																						:light="$_admnTabLyt_styleStepperActionButtonLight"
																						:outlined="$_admnTabLyt_styleStepperActionButtonOutlined"
																						:rounded="$_admnTabLyt_styleStepperActionButtonRounded"
																						:small="$_admnTabLyt_styleStepperActionButtonSmall"
																						:text="$_admnTabLyt_styleStepperActionButtonFlat"

																						:disabled="!validation.passed && !validation.valid"

																						@click="$_admnTabLyt_submit()"
																						v-text="$_admnTabLyt_langSubmitButton" />
																			</v-col>
																			<v-col cols="auto">
																				<v-btn	class="customVBtn"
																						:block="$_admnTabLyt_styleStepperActionButtonBlock"
																						:color="$_admnTabLyt_styleStepperActionButtonColor"
																						:dark="$_admnTabLyt_styleStepperActionButtonDark"
																						:depressed="$_admnTabLyt_styleStepperActionButtonDepressed"
																						:elevation="$_admnTabLyt_styleStepperActionButtonElevation"
																						:large="$_admnTabLyt_styleStepperActionButtonLarge"
																						:light="$_admnTabLyt_styleStepperActionButtonLight"
																						:outlined="$_admnTabLyt_styleStepperActionButtonOutlined"
																						:rounded="$_admnTabLyt_styleStepperActionButtonRounded"
																						:small="$_admnTabLyt_styleStepperActionButtonSmall"
																						:text="$_admnTabLyt_styleStepperActionButtonFlat"

																						:disabled="dataCount_ == 0"

																						@click="$_admnTabLyt_next()"
																						v-text="$_admnTabLyt_langNextButton" />
																			</v-col>
																			<v-col cols="auto">
																				<admin-import-dialog
																						:contentKey="contentKey"
																						:contents="contents"
																						:inits="inits"
																						@imported="$_admnTabLyt_imported()" />
																			</v-col>
																		</v-row>
																	</v-card-actions>
																</v-card>
															</v-form>
														</validation-observer>
													</v-col>
												</v-row>
											</v-stepper-content>
											<!-- stepper body (confirm) -->
											<v-stepper-content
													class="stepperContent_"
													step="2">
												<v-row>
													<v-col>
														<v-card class="customVCard"
																:color="$_admnTabLyt_styleStepperBodyCardColor"
																:dark="$_admnTabLyt_styleStepperBodyCardDark"
																:elevation="$_admnTabLyt_styleStepperBodyCardElevation"
																:flat="$_admnTabLyt_styleStepperBodyCardFlat"
																:hover="$_admnTabLyt_styleStepperBodyCardHover"
																:light="$_admnTabLyt_styleStepperBodyCardLight"
																:outlined="$_admnTabLyt_styleStepperBodyCardOutlined"
																:raised="$_admnTabLyt_styleStepperBodyCardRaised"
																:tile="$_admnTabLyt_styleStepperBodyCardTile">
															<v-row>
																<v-col>
																	<v-data-table
																			:headers="$_admnTabLyt_getDataHeaders(contentVals)"
																			:items="dataRows_">
																		<template v-slot:[`item.action`]="{ item }">
																			<v-row>
																				<v-col cols="auto">
																					<v-icon
																							small
																							@click="$_admnTabLyt_edit(item)">
																						edit
																					</v-icon>
																				</v-col>
																				<v-col cols="auto">
																					<v-icon
																							small
																							@click="$_admnTabLyt_delete(item)">
																						delete
																					</v-icon>
																				</v-col>
																			</v-row>
																		</template>
																	</v-data-table>
																	<admin-edit-dialog
																			:contentKey="contentKey"
																			:inits="inits"
																			:contents="contents" />
																</v-col>
															</v-row>
														</v-card>
														<v-card	class="customVCard"
																color="transparent"
																flat>
															<v-card-actions>
																<v-row	align="center"
																		justify="center">
																	<v-col cols="auto">
																		<v-btn	class="customVBtn"
																				:block="$_admnTabLyt_styleStepperActionButtonBlock"
																				:color="$_admnTabLyt_styleStepperActionButtonColor"
																				:dark="$_admnTabLyt_styleStepperActionButtonDark"
																				:depressed="$_admnTabLyt_styleStepperActionButtonDepressed"
																				:elevation="$_admnTabLyt_styleStepperActionButtonElevation"
																				:large="$_admnTabLyt_styleStepperActionButtonLarge"
																				:light="$_admnTabLyt_styleStepperActionButtonLight"
																				:outlined="$_admnTabLyt_styleStepperActionButtonOutlined"
																				:rounded="$_admnTabLyt_styleStepperActionButtonRounded"
																				:small="$_admnTabLyt_styleStepperActionButtonSmall"
																				:text="$_admnTabLyt_styleStepperActionButtonFlat"
																				@click="$_admnTabLyt_back()"
																				v-text="$_admnTabLyt_langBackButton" />
																	</v-col>
																	<v-col cols="auto">
																		<v-btn	class="customVBtn"
																				:block="$_admnTabLyt_styleStepperActionButtonBlock"
																				:color="$_admnTabLyt_styleStepperActionButtonColor"
																				:dark="$_admnTabLyt_styleStepperActionButtonDark"
																				:depressed="$_admnTabLyt_styleStepperActionButtonDepressed"
																				:elevation="$_admnTabLyt_styleStepperActionButtonElevation"
																				:large="$_admnTabLyt_styleStepperActionButtonLarge"
																				:light="$_admnTabLyt_styleStepperActionButtonLight"
																				:outlined="$_admnTabLyt_styleStepperActionButtonOutlined"
																				:rounded="$_admnTabLyt_styleStepperActionButtonRounded"
																				:small="$_admnTabLyt_styleStepperActionButtonSmall"
																				:text="$_admnTabLyt_styleStepperActionButtonFlat"
																				@click="$_admnTabLyt_confirm(contentKey)"
																				v-text="$_admnTabLyt_langConfirmButton" />
																	</v-col>
																</v-row>
															</v-card-actions>
														</v-card>
													</v-col>
												</v-row>
												<v-dialog
														v-model="onProgressConfirm_"
														max-width="50vw"
														persistent>
													<v-card class="customVCard"
															:color="$_admnTabLyt_styleStepperBodyCardColor"
															:dark="$_admnTabLyt_styleStepperBodyCardDark"
															:elevation="$_admnTabLyt_styleStepperBodyCardElevation"
															:flat="$_admnTabLyt_styleStepperBodyCardFlat"
															:hover="$_admnTabLyt_styleStepperBodyCardHover"
															:light="$_admnTabLyt_styleStepperBodyCardLight"
															:outlined="$_admnTabLyt_styleStepperBodyCardOutlined"
															:raised="$_admnTabLyt_styleStepperBodyCardRaised"
															:tile="$_admnTabLyt_styleStepperBodyCardTile">
														<v-card-title>
															<v-row justify="center">
																<v-col cols="auto">
																	<span class="caption">Now on progress... It may takes a few minutes...</span>
																</v-col>
															</v-row>
														</v-card-title>
														<v-card-text>
															<v-row justify="center">
																<v-col cols="auto">
																	<span class="caption" v-text="$store.state.admin.result.length + $store.state.admin.error.length" />
																</v-col>
																<v-col cols="auto">
																	/
																</v-col>
																<v-col cols="auto">
																	<span class="caption" v-text="dataCount_" />
																</v-col>
															</v-row>
														</v-card-text>
														<v-card-text>
															<v-row justify="center">
																<v-col>
																	<v-progress-linear
																			buffer-value="100"
																			:value="($store.state.admin.result.length + $store.state.admin.error.length) / dataCount_ * 100" />
																</v-col>
															</v-row>
														</v-card-text>
													</v-card>
												</v-dialog>
											</v-stepper-content>
											<!-- stepper body (finish) -->
											<v-stepper-content
													class="stepperContent_"
													step="3">
												<v-row>
													<v-col>
														<v-card class="customVCard"
																:color="$_admnTabLyt_styleStepperBodyCardColor"
																:dark="$_admnTabLyt_styleStepperBodyCardDark"
																:elevation="$_admnTabLyt_styleStepperBodyCardElevation"
																:flat="$_admnTabLyt_styleStepperBodyCardFlat"
																:hover="$_admnTabLyt_styleStepperBodyCardHover"
																:light="$_admnTabLyt_styleStepperBodyCardLight"
																:outlined="$_admnTabLyt_styleStepperBodyCardOutlined"
																:raised="$_admnTabLyt_styleStepperBodyCardRaised"
																:tile="$_admnTabLyt_styleStepperBodyCardTile">
															<v-card-title>
																<v-row>
																	<v-col>
																		<span class="body-1">Finished</span>
																	</v-col>
																</v-row>
															</v-card-title>
															<v-card-text>
																<template v-if="!isEmpty($store.state.admin.result)">
																	<v-row>
																		<v-col>
																			<v-alert
																					class="customVAlert"
																					color="info"
																					outlined>
																				<v-row align="center" dense>
																					<v-col>
																						<v-expansion-panels flat>
																							<v-expansion-panel>
																								<v-expansion-panel-header>
																									Result
																								</v-expansion-panel-header>
																								<v-expansion-panel-content>
																									<pre	class="prettyprint caption"
																											v-text="$store.state.admin.result" />
																								</v-expansion-panel-content>
																							</v-expansion-panel>
																						</v-expansion-panels>
																					</v-col>
																					<v-col cols="auto">
																						<clipboard-button :text="JSON.stringify($store.state.admin.result)" />
																					</v-col>
																				</v-row>
																			</v-alert>
																		</v-col>
																	</v-row>
																</template>
																<template v-if="!isEmpty($store.state.admin.error)">
																	<v-row>
																		<v-col>
																			<v-alert
																					class="customVAlert"
																					color="error"
																					outlined>
																				<v-row align="center" dense>
																					<v-col>
																						<v-expansion-panels flat>
																							<v-expansion-panel>
																								<v-expansion-panel-header>
																									Error
																								</v-expansion-panel-header>
																								<v-expansion-panel-content>
																									<pre	class="prettyprint caption"
																											v-text="$store.state.admin.error" />
																								</v-expansion-panel-content>
																							</v-expansion-panel>
																						</v-expansion-panels>
																					</v-col>
																					<v-col cols="auto">
																						<clipboard-button :text="JSON.stringify($store.state.admin.error)" />
																					</v-col>
																				</v-row>
																			</v-alert>
																		</v-col>
																	</v-row>
																</template>
															</v-card-text>
														</v-card>
														<v-card	class="customVCard"
																color="transparent"
																flat>
															<v-card-actions>
																<v-row	align="center"
																		justify="center">
																	<v-col cols="auto">
																		<v-btn	class="customVBtn"
																				:block="$_admnTabLyt_styleStepperActionButtonBlock"
																				:color="$_admnTabLyt_styleStepperActionButtonColor"
																				:dark="$_admnTabLyt_styleStepperActionButtonDark"
																				:depressed="$_admnTabLyt_styleStepperActionButtonDepressed"
																				:elevation="$_admnTabLyt_styleStepperActionButtonElevation"
																				:large="$_admnTabLyt_styleStepperActionButtonLarge"
																				:light="$_admnTabLyt_styleStepperActionButtonLight"
																				:outlined="$_admnTabLyt_styleStepperActionButtonOutlined"
																				:rounded="$_admnTabLyt_styleStepperActionButtonRounded"
																				:small="$_admnTabLyt_styleStepperActionButtonSmall"
																				:text="$_admnTabLyt_styleStepperActionButtonFlat"
																				@click="$_admnTabLyt_finish(contentKey)"
																				v-text="$_admnTabLyt_langOkButton" />
																	</v-col>
																</v-row>
															</v-card-actions>
														</v-card>
													</v-col>
												</v-row>
											</v-stepper-content>
										</v-stepper-items>
									</v-stepper>
								</v-col>
							</v-row>
						</v-tab-item>
					</template>
				</v-tabs-items>
			</v-col>
			<v-spacer />
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'AdminTabLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				// tab
				tabNumber_: 0,
				tabTitle_: null,
				// stepper
				stepNumber_: 1,
				steps_: {
					input: {
						stepNumber: 1,
						title: 'Input'
					},
					confirm: {
						stepNumber: 2,
						title: 'Confirm'
					},
					finish: {
						stepNumber: 3,
						title: 'Finish'
					}
				},
				completedSteps_: {
					input: false,
					confirm: false,
					finish: false
				},
				// data
				dataCount_: 0,
				dataRows_: [],
				// edit
				showDialogEdit_: false,
				editKey_: null,
				editItem_: {},
				// import
				importId_: null,
				showDialogImport_: false,
				errorMessageImport_: null,
				// confirm
				onProgressConfirm_: false
			}
		},
		computed: {
			// params
			$_admnTabLyt_params() {
				const self_ = this;
				const route_ = self_.$route
				return route_.params
			},
			$_admnTabLyt_paramsOperationType() {
				const self_ = this;
				const params_ = self_.$_admnTabLyt_params;
				if(self_.isEmpty(params_)) { return null }
				return self_.convertCaseToCamel(params_.operationType)
			},
			$_admnTabLyt_paramsOperationName() {
				const self_ = this;
				const params_ = self_.$_admnTabLyt_params;
				if(self_.isEmpty(params_)) { return null }
				return self_.convertCaseToCamel(params_.operationName)
			},
			// state
			$_admnTabLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			// lang
			$_admnTabLyt_langSubmitButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'submitButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_admnTabLyt_langNextButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'nextButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_admnTabLyt_langBackButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'backButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_admnTabLyt_langConfirmButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'confirmButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_admnTabLyt_langFinishButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'okButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_admnTabLyt_langFinishTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'finishTitle')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_admnTabLyt_langFinishText() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'finishText')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_admnTabLyt_langOkButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'okButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			// (content)
			$_admnTabLyt_langContentTabTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.tabTitle;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_admnTabLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_admnTabLyt_langContentSubTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.subTitle;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_admnTabLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_admnTabLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// style
			$_admnTabLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_admnTabLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_admnTabLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_admnTabLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'actionButton')
			},
			$_admnTabLyt_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_admnTabLyt_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_admnTabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_admnTabLyt_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_admnTabLyt_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_admnTabLyt_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_admnTabLyt_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_admnTabLyt_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_admnTabLyt_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_admnTabLyt_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_admnTabLyt_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_admnTabLyt_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			$_admnTabLyt_styleTabs() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'tabs')
			},
			$_admnTabLyt_styleTabsBackgroundColor() {
				const self_ = this;
				const tabs_ = self_.$_admnTabLyt_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.backgroundColor)
			},
			$_admnTabLyt_styleTabsColor() {
				const self_ = this;
				const tabs_ = self_.$_admnTabLyt_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.color)
			},
			$_admnTabLyt_styleTabsDark() {
				const self_ = this;
				const tabs_ = self_.$_admnTabLyt_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.dark)
			},
			$_admnTabLyt_styleTabsHideSlider() {
				const self_ = this;
				const tabs_ = self_.$_admnTabLyt_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.hideSlider)
			},
			$_admnTabLyt_styleTabsLight() {
				const self_ = this;
				const tabs_ = self_.$_admnTabLyt_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.light)
			},
			$_admnTabLyt_styleTabsSliderColor() {
				const self_ = this;
				const tabs_ = self_.$_admnTabLyt_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.sliderColor)
			},
			$_admnTabLyt_styleTab() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'tab')
			},
			$_admnTabLyt_styleTabDark() {
				const self_ = this;
				const tab_ = self_.$_admnTabLyt_styleTab;
				if(self_.isFalse(tab_)) { return null }
				return self_.getStylesVal(tab_.dark)
			},
			$_admnTabLyt_styleTabLight() {
				const self_ = this;
				const tab_ = self_.$_admnTabLyt_styleTab;
				if(self_.isFalse(tab_)) { return null }
				return self_.getStylesVal(tab_.light)
			},
			$_admnTabLyt_styleHeaderSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'headerSheet')
			},
			$_admnTabLyt_styleHeaderSheetColor() {
				const self_ = this;
				const headerSheet_ = self_.$_admnTabLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.color)
			},
			$_admnTabLyt_styleHeaderSheetDark() {
				const self_ = this;
				const headerSheet_ = self_.$_admnTabLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.dark)
			},
			$_admnTabLyt_styleHeaderSheetElevation() {
				const self_ = this;
				const headerSheet_ = self_.$_admnTabLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.elevation)
			},
			$_admnTabLyt_styleHeaderSheetLight() {
				const self_ = this;
				const headerSheet_ = self_.$_admnTabLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.dark)
			},
			$_admnTabLyt_styleBodySheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'bodySheet')
			},
			$_admnTabLyt_styleBodySheetColor() {
				const self_ = this;
				const bodySheet_ = self_.$_admnTabLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.color)
			},
			$_admnTabLyt_styleBodySheetDark() {
				const self_ = this;
				const bodySheet_ = self_.$_admnTabLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.dark)
			},
			$_admnTabLyt_styleBodySheetElevation() {
				const self_ = this;
				const bodySheet_ = self_.$_admnTabLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.elevation)
			},
			$_admnTabLyt_styleBodySheetLight() {
				const self_ = this;
				const bodySheet_ = self_.$_admnTabLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.light)
			},
			$_admnTabLyt_styleStepper() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepper')
			},
			$_admnTabLyt_styleStepperDark() {
				const self_ = this;
				const stepper_ = self_.$_admnTabLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.dark)
			},
			$_admnTabLyt_styleStepperLight() {
				const self_ = this;
				const stepper_ = self_.$_admnTabLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.light)
			},
			$_admnTabLyt_styleStepperStepColor() {
				const self_ = this;
				const stepper_ = self_.$_admnTabLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.stepColor)
			},
			$_admnTabLyt_styleStepperCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperCard')
			},
			$_admnTabLyt_styleStepperCardColor() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_admnTabLyt_styleStepperCardDark() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_admnTabLyt_styleStepperCardElevation() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_admnTabLyt_styleStepperCardFlat() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_admnTabLyt_styleStepperCardHover() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_admnTabLyt_styleStepperCardLight() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_admnTabLyt_styleStepperCardOutlined() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_admnTabLyt_styleStepperCardRaised() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_admnTabLyt_styleStepperCardTile() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_admnTabLyt_styleStepperHeaderCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperHeaderCard')
			},
			$_admnTabLyt_styleStepperHeaderCardColor() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_admnTabLyt_styleStepperHeaderCardDark() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_admnTabLyt_styleStepperHeaderCardElevation() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_admnTabLyt_styleStepperHeaderCardFlat() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_admnTabLyt_styleStepperHeaderCardHover() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_admnTabLyt_styleStepperHeaderCardLight() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_admnTabLyt_styleStepperHeaderCardOutlined() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_admnTabLyt_styleStepperHeaderCardRaised() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_admnTabLyt_styleStepperHeaderCardTile() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_admnTabLyt_styleStepperBodyCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperBodyCard')
			},
			$_admnTabLyt_styleStepperBodyCardColor() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_admnTabLyt_styleStepperBodyCardDark() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_admnTabLyt_styleStepperBodyCardElevation() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_admnTabLyt_styleStepperBodyCardFlat() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_admnTabLyt_styleStepperBodyCardHover() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_admnTabLyt_styleStepperBodyCardLight() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_admnTabLyt_styleStepperBodyCardOutlined() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_admnTabLyt_styleStepperBodyCardRaised() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_admnTabLyt_styleStepperBodyCardTile() {
				const self_ = this;
				const card_ = self_.$_admnTabLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_admnTabLyt_styleStepperActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperActionButton')
			},
			$_admnTabLyt_styleStepperActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_admnTabLyt_styleStepperActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_admnTabLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_admnTabLyt_styleStepperActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_admnTabLyt_styleStepperActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_admnTabLyt_styleStepperActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_admnTabLyt_styleStepperActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_admnTabLyt_styleStepperActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_admnTabLyt_styleStepperActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_admnTabLyt_styleStepperActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_admnTabLyt_styleStepperActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_admnTabLyt_styleStepperActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_admnTabLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_admnTabLyt_styleContentBigImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_admnTabLyt_styleContentBigImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_admnTabLyt_styleContentBigImage(contentVals);
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			},
			$_admnTabLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_admnTabLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_admnTabLyt_styleContentImage(contentVals);
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		},
		watch: {
			$route() { 
				const self_ = this;
				self_.$_admnTabLyt_setTabNumber()
			}
		},
		created() {
			const self_ = this;
			self_.$_admnTabLyt_reset()
		},
		beforeMount() {
			const self_ = this;
			self_.$_admnTabLyt_setTabNumber()
		},
		methods: {
			$_admnTabLyt_setTabNumber() {
				const self_ = this;
				if(self_.isFalse(self_.$_admnTabLyt_paramsOperationName)) {
					self_.tabNumber_ = 0;
				} else {
					let count_ = 0;
					let result_ = 0;
					Object.keys(self_.contents).forEach(key => {
						if(key == self_.$_admnTabLyt_paramsOperationName) {
							result_ = count_;
						}
						count_++;
					})
					self_.tabNumber_ = result_;
				}
			},
			$_admnTabLyt_makeDataRows() {
				const self_ = this;

				const data_ = self_.getAdminState('data')

				self_.dataCount_ = 0;
				self_.dataRows_ = []

				Object.keys(data_).forEach(dataKey => {
					let row_ = {}
					// row number
					row_.row = dataKey;
					// data
					Object.keys(data_[dataKey]).forEach(key => {
						row_[key] = data_[dataKey][key]
					})
					self_.dataRows_.push(row_)
					self_.dataCount_++;
				})
			},
			$_admnTabLyt_getDataHeaders(contentVals) {
				const self_ = this;

				const items_ = contentVals.inputItems;
				const headers_ = []
				// row number				
				headers_.push({ text: 'Row', value: 'row' })
				// data
				Object.keys(items_).forEach(key => {
					headers_.push({
						text: items_[key].title,
						value: key
					})
				})
				// for edit action
				headers_.push({ text: 'Action', value: 'action' })

				return headers_
			},
			$_admnTabLyt_changeTab() {
				const self_ = this;
				const router_ = self_.$router;
				// operation type & key
				const keys_ = Object.keys(self_.contents)
				const operationName_ = keys_[self_.tabNumber_]

				if(self_.isFalse(operationName_)) { return }

				// reset everything
				self_.$_admnTabLyt_reset()
				// router replace
				router_.replace({
					name: 'adminOperationName',
					params: {
						operationType: self_.$_admnTabLyt_paramsOperationType,
						operationName: operationName_
					}
				})
			},
			$_admnTabLyt_submit() {
				const self_ = this;
				const refs_ = self_.$refs;
				const vuetify_ = self_.$vuetify;

				let data_ = self_.getAdminState('data')

				// add input to data
				const input_ = self_.getAdminState('input')
				data_[self_.dataCount_+1] = input_;
				// set state
				self_.setAdminState('data', data_)
				self_.setAdminState('input', {})
				// make data rows
				self_.$_admnTabLyt_makeDataRows()
				// reset input
				self_.$_admnTabLyt_resetInput()

				self_.$_admnTabLyt_next()
			},
			$_admnTabLyt_next() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				Promise.resolve().then(() => {
					self_.completedSteps_.input = true;
					self_.stepNumber_ = 2;
					return Promise.resolve()
				}).then(() => {
					vuetify_.goTo('#_admnTabLyt_stepperTop')
				})
			},
			$_admnTabLyt_back() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				Promise.resolve().then(() => {
					self_.completedSteps_.input = false;
					self_.stepNumber_ = 1;
					return Promise.resolve()
				}).then(() => {
					vuetify_.goTo('#_admnTabLyt_stepperTop')
				})
			},
			$_admnTabLyt_confirm(contentKey) {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				self_.onProgressConfirm_ = true;

				Promise.resolve().then(() => {
					return self_.adminSetData(contentKey)
				}).then(() => {
					self_.onProgressConfirm_ = false;

					self_.completedSteps_.confirm = true;
					self_.stepNumber_ = 3;
					return Promise.resolve()
				}).then(() => {
					vuetify_.goTo('#_admnTabLyt_stepperTop')
				})
			},
			$_admnTabLyt_finish(contentKey) {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				Promise.resolve().then(() => {
					// reset
					self_.$_admnTabLyt_reset()
					return Promise.resolve()
				}).then(() => {
					vuetify_.goTo('#_admnTabLyt_top')
				})
			},
			$_admnTabLyt_imported() {
				const self_ = this;
				// make data rows
				self_.$_admnTabLyt_makeDataRows()
				// reset input
				self_.$_admnTabLyt_resetInput()

				self_.$_admnTabLyt_next()
			},
			$_admnTabLyt_edit(item) {
				const self_ = this;

				let key_ = null;
				let item_ = {}

				Object.keys(item).forEach(key => {
					if(key == 'row') {
						key_ = item[key] - 1;
					} else {
						item_[key] = item[key]
					}
				})

				self_.setAdminState('editKey', key_)
				self_.setAdminState('edititem', item_)

				self_.setAdminState('showEditDialog', true)
			},
			$_admnTabLyt_edited() {
				const self_ = this;

				const editKey_ = self_.getAdminState('editKey')
				const editItem_ = self_.getAdminState('editItem')

				Object.keys(self_.editItem_).forEach(key => {
					self_.dataRows_[self_.editKey_][key] = self_.editItem_[key]	
				})

				self_.$_admnTabLyt_resetEdit()
			},
			$_admnTabLyt_delete(item) {
				const self_ = this;
				// delete from state
				let data_ = self_.getAdminState('data')
				delete data_[item.row]
				self_.setAdminState('data', data_)
				// make data rows
				self_.$_admnTabLyt_makeDataRows()
			},
			$_admnTabLyt_reset(contentKey) {
				const self_ = this;
				self_.$_admnTabLyt_resetSteps()
				self_.$_admnTabLyt_resetInput()
				self_.$_admnTabLyt_resetData()
				self_.$_admnTabLyt_resetEdit()
				self_.$_admnTabLyt_resetState()
			},
			$_admnTabLyt_resetSteps() {
				const self_ = this;
				self_.stepNumber_ = 1;
				self_.completedSteps_ = { input: false, confirm: false, finish: false }
			},
			$_admnTabLyt_resetInput() {
				const self_ = this;
				const refs_ = self_.$refs;
				const observer_ = refs_.observerInput;
				if(!self_.isEmpty(observer_)) {
					Object.keys(observer_).forEach(key => observer_[key].reset())
				}
			},
			$_admnTabLyt_resetData() {
				const self_ = this;
				self_.dataCount_ = 0;
				self_.dataRows_ = []
			},
			$_admnTabLyt_resetEdit() {
				const self_ = this;
				self_.setAdminState('editKey', null)
				self_.setAdminState('edititem', {})
			},
			$_admnTabLyt_resetState() {
				const self_ = this;
				self_.setAdminState('input', {})
				self_.setAdminState('data', {})
				self_.setAdminState('result', [])
				self_.setAdminState('error', [])
			}
		}
	}
</script>

<style scoped>
	.row_ {
		padding-top: 24px !important;
	}
	.tabs_.v-tabs {
		min-width: 240px !important;
	}
	.tabs_ .v-tab {
		min-width: 240px !important;
		margin: 12px 12px 0 12px !important;
	}
	.tabs_.v-tabs-items {
		background-color: transparent !important;
	}
	.stepper_ {
		box-shadow: none !important;
		background-color: transparent !important;
	}
	.stepperHeader_ {
		background-color: transparent !important;
		box-shadow: none !important;
		height: 80px !important;
	}
	.stepperItem_ {
		background-color: transparent !important;
		box-shadow: none !important;
	}
	.stepperStep_ {
		padding: 16px !important;
	}
	.stepperContent_ {
		margin: 0 !important; 
		padding: 0 !important;
	}
	.card_ {
		padding-top: 24px !important;
		padding-bottom: 24px !important;
	}
</style>
